module.exports = __webpack_public_path__ + "static/interior01-5fee2129ecd9910e98ec2d46786798c9.jpg";